import JSZip from 'jszip';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { taxFilesStartLoading } from '../../../../actions/taxpayers/TaxDocuments';
import { complianceOpinion } from '../../../../helpers/certificate';
import { useForm } from '../../../../hooks/useForm';
import { saveAs } from 'file-saver';


export const ComplianceOpinionDetailsScreen = ({ taxpayerId, isAdmin = false }) => {

  const { taxfiles } = useSelector(state => state.certificate)

  const dispatch = useDispatch();

  const { formValues, setFormValues } = useForm({
    taxfilesOptions: []
  })

  const { taxfilesOptions } = formValues;

  useEffect(() => {
    if(taxfiles.length === 0){
      dispatch(taxFilesStartLoading(taxpayerId))
    }

    setFormValues(prevState => {
      return{
        ...prevState,
        taxfilesOptions: complianceOpinion(taxfiles)
      }
    })
  }, [taxfiles, dispatch, setFormValues, taxpayerId]);

  const downloadCertificate = (taxfile, e) => {
    e.preventDefault();
    
    var zip = new JSZip();
    
    zip.file("OpinionCumplimiento.pdf", taxfile.documentContent, {base64: true});

    zip.generateAsync({type:"blob"}).then(function(content) {
      saveAs(content, taxfile.documentName + '.pdf');
    });
  }

  return (
    <div className="col-md-6 mt-4">
      {
        isAdmin ? (
            <h3 className="text-center">Archivos CRM</h3>
            )
            :
            (
              <button>
              </button>
            )
      }
      <div className='table-responsive'>
      <table className="table table-striped">
        <thead>
          <tr>
            <td></td>
            <td>Tipo de documento</td>
            <td className="text-center">Acciones</td>
          </tr>
        </thead>
        <tbody>
          {
            taxfilesOptions.length === 0 ? (
              <tr>
                <td colSpan="3">
                  <div className="alert alert-primary text-center mb-0" role="alert">
                    No se ha agregado información
                  </div>
                </td>
              </tr>
            )
            :
            (
              taxfilesOptions.map((certificate, index) => {
                return(
                  <tr key={index}>
                    <td></td>
                    <td>{certificate.documentName}</td>
                    <td className="text-center">
                      <button className="btn btn-primary" data-toggle="tooltip" data-placement="bottom" title="Descargar Archivos" onClick={downloadCertificate.bind(this, certificate)}>
                        <i className="far fa-file-pdf"></i>
                      </button>
                    </td>
                  </tr>
                )
              })
            )
          }
        </tbody>
      </table>
      </div>
    </div>
  );
}